import { render, staticRenderFns } from "./ErrorTitle.vue?vue&type=template&id=06829a2a&scoped=true&"
import script from "./ErrorTitle.vue?vue&type=script&lang=js&"
export * from "./ErrorTitle.vue?vue&type=script&lang=js&"
import style0 from "./ErrorTitle.vue?vue&type=style&index=0&id=06829a2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06829a2a",
  null
  
)

export default component.exports